import { Button, ButtonGroup, Box, Icon, Tooltip } from '@chakra-ui/react'
import React from 'react'
import { WarningTwoIcon } from '@chakra-ui/icons'

interface ToggleProps {
  handleClick: (state: boolean) => void
  isActive?: boolean
  isMixed?: boolean
  isLoading?: boolean
}

export const Toggle: React.FC<ToggleProps> = ({
  handleClick,
  isActive,
  isMixed = false,
  isLoading = false,
}) => {
  return (
    <Box position="relative" display="inline-block">
      {isMixed && (
        <Tooltip
          label="Some devices in this group are ON, others are OFF"
          hasArrow
          placement="top"
        >
          <Box position="absolute" left="50%" transform="translateX(-50%)" top="-30px">
            <Icon as={WarningTwoIcon} color="yellow.500" boxSize={4} />
          </Box>
        </Tooltip>
      )}
      <ButtonGroup isAttached variant="outline" size="sm">
        <Button
          isLoading={isLoading}
          onClick={() => handleClick(false)}
          colorScheme={isMixed ? 'gray' : !isActive ? 'red' : 'gray'}
          variant={!isActive && !isMixed ? 'solid' : 'outline'}
        >
          Off
        </Button>
        <Button
          isLoading={isLoading}
          onClick={() => handleClick(true)}
          colorScheme={isMixed ? 'gray' : isActive ? 'blue' : 'gray'}
          variant={isActive && !isMixed ? 'solid' : 'outline'}
        >
          On
        </Button>
      </ButtonGroup>
    </Box>
  )
}
